import { Separator } from '../../ui';
import { TProps } from '.';

const ProfileDetailUserDataBio = ({ userData }: Pick<TProps, 'userData'>) => {

	if (!userData?.aboutYou) {
		return <></>;
	}

	return (
		<>
			<p className={`text-md text-muted-foreground mx-auto px-2`}>
				{userData.aboutYou}
			</p>
			<Separator className='bg-muted' />
		</>
	);

};

export default ProfileDetailUserDataBio;
